import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import Zoom from "react-reveal/Zoom";
import { logo2Icon } from "../../Assets";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import {
  changeIsRegistered,
  getRegisterDetails,
  initialRegDetails,
  saveRegisterDetails,
} from "../../Redux/actions";
import { removeUnderScore } from "../../helpers";

const schema = yup
  .object({
    account_name: yup.string().required().max(255),
    email: yup.string().required().max(255),
    first_name: yup.string().required().max(255),
    last_name: yup.string().required().max(255),
    timezone: yup.string().required(),
    parent_code2: yup.string(),
    password: yup.string().required().min(8).max(255),
    password_confirmation: yup
      .string()
      .oneOf([yup.ref("password"), null], "Passwords must match"),
  })
  .required();

const Register = () => {
  const { register_details, is_registered } = useSelector(
    (state) => state.authReducer
  );
  const { toastMsgs } = useSelector((state) => state.toastReducer);
  const history = useHistory();
  const dispatch = useDispatch();

  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
  });

  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const checkToastMsg = () => {
    if (toastMsgs.length > 0) {
      const findSuccessInx = toastMsgs.findIndex((p) => p.msgtype == "success");
      if (findSuccessInx > -1) {
        setSuccessMsg(toastMsgs[findSuccessInx].text);
      } else {
        setSuccessMsg("");
      }
      const findErrorInx = toastMsgs.findIndex((p) => p.msgtype == "error");
      if (findErrorInx > -1) {
        setErrorMsg(toastMsgs[findErrorInx].text);
      } else {
        setErrorMsg("");
      }
    } else {
      setSuccessMsg("");
      setErrorMsg("");
    }
  };

  useEffect(() => {
    checkToastMsg();
  }, [toastMsgs]);

  useEffect(() => {
    dispatch(getRegisterDetails());
    if (is_registered) {
      history.push("/");
    }
  }, [is_registered]);

  useEffect(() => {
    return () => {
      dispatch(initialRegDetails());
    };
  }, []);

  const [disableSubmit, setDisableSubmit] = useState(true);
  const [registerForm, setRegisterForm] = useState({
    account_name: "",
    email: "",
    first_name: "",
    last_name: "",
    timezone: "",
    parent_code2: "",
    password: "",
    password_confirmation: "",
  });

  const changeInputHandler = (input, val) => {
    setValue(input, val);
    setRegisterForm((prevState) => ({ ...prevState, [input]: val }));
  };

  const onSubmit = (data) => {
    console.log("sub_data:", data);
    dispatch(saveRegisterDetails(data));
  };

  return (
    <>
      <div className="logo_container2">
        <a href="/">
          <img src={logo2Icon} />
        </a>
      </div>
      <div className="content">
        <section className="register-wrap">
          <div className="users form">
            <Zoom opposite when={errorMsg !== ""}>
              <>
                <div id="flashMessage" class="new_flash_message_error">
                  <p>{errorMsg}</p>
                </div>
              </>
            </Zoom>
            <form
              onSubmit={handleSubmit(onSubmit)}
              className=""
              id="UserRegisterForm"
            >
              <fieldset>
                <h4 className="login-header bordered">Register User</h4>
                <ul className="register-list">
                  <li>
                    <div className="col">
                      <div className="input text">
                        <label for="UserAccountName" className="required">
                          Account Name
                        </label>
                        <input
                          id="UserAccountName"
                          {...register("account_name")}
                          autoComplete="new-password"
                          value={registerForm?.account_name}
                          onChange={(e) => {
                            changeInputHandler(
                              "account_name",
                              e?.target?.value
                            );
                          }}
                        />
                        {errors?.account_name && (
                          <label className="error">
                            {removeUnderScore(errors.account_name?.message)}
                          </label>
                        )}
                      </div>
                    </div>
                    <div className="col">
                      <div className="input email required">
                        <label for="UserEmail" className="required">
                          Email
                        </label>
                        <input
                          {...register("email")}
                          type="email"
                          id="UserEmail"
                          value={registerForm?.email}
                          onChange={(e) => {
                            changeInputHandler("email", e?.target?.value);
                          }}
                        />
                        {errors?.email && (
                          <label className="error">
                            {removeUnderScore(errors.email?.message)}
                          </label>
                        )}
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="col">
                      <div className="input text required">
                        <label for="UserFirstName" className="required">
                          First Name
                        </label>
                        <input
                          {...register("first_name")}
                          id="UserFirstName"
                          value={registerForm?.first_name}
                          onChange={(e) => {
                            changeInputHandler("first_name", e?.target?.value);
                          }}
                        />
                        {errors?.first_name && (
                          <label className="error">
                            {removeUnderScore(errors.first_name?.message)}
                          </label>
                        )}
                      </div>
                    </div>
                    <div className="col">
                      <div className="input text required">
                        <label for="UserLastName" className="required">
                          Last Name
                        </label>
                        <input
                          {...register("last_name")}
                          id="UserLastName"
                          value={registerForm?.last_name}
                          onChange={(e) => {
                            changeInputHandler("last_name", e?.target?.value);
                          }}
                        />
                        {errors?.last_name && (
                          <label className="error">
                            {removeUnderScore(errors.last_name?.message)}
                          </label>
                        )}
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="col">
                      <div className="input text">
                        <label for="UserParentCode2">
                          Reference Code (If Any)
                        </label>
                        <input
                          {...register("parent_code2")}
                          id="UserParentCode2"
                          value={registerForm?.parent_code2}
                          onChange={(e) => {
                            changeInputHandler(
                              "parent_code2",
                              e?.target?.value
                            );
                          }}
                        />
                        {errors?.parent_code2 && (
                          <label className="error">
                            {removeUnderScore(errors.parent_code2?.message)}
                          </label>
                        )}
                      </div>
                    </div>
                    <div className="col">
                      <div className="input select">
                        <label className="required">Timezone</label>
                        <div
                          className="select-div input-group"
                          style={{ display: "block" }}
                        >
                          <select
                            id="UserTimezone"
                            {...register("timezone")}
                            value={registerForm?.timezone}
                            onChange={(e) => {
                              changeInputHandler("timezone", e?.target?.value);
                            }}
                          >
                            <option value="">Select Timezone</option>
                            {register_details?.get_all_timezone &&
                              Object.keys(
                                register_details?.get_all_timezone
                              ).map((timezone, index) => {
                                return (
                                  <option value={timezone} key={index}>
                                    {
                                      register_details?.get_all_timezone?.[
                                        timezone
                                      ]
                                    }
                                  </option>
                                );
                              })}
                          </select>
                        </div>
                        {errors?.timezone && (
                          <label className="error">
                            {removeUnderScore(errors.timezone?.message)}
                          </label>
                        )}
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="col">
                      <div className="input password required">
                        <label for="UserPassword" className="required">
                          Password
                        </label>
                        <input
                          {...register("password")}
                          type="password"
                          autoComplete="new-password"
                          id="UserPassword"
                          value={registerForm?.password}
                          onChange={(e) => {
                            changeInputHandler("password", e?.target?.value);
                          }}
                        />
                        {errors?.password && (
                          <label className="error">
                            {removeUnderScore(errors.password?.message)}
                          </label>
                        )}
                      </div>
                    </div>
                    <div className="col">
                      <div className="input password">
                        <label for="UserConfirmPassword" className="required">
                          Confirm Password
                        </label>
                        <input
                          {...register("password_confirmation")}
                          type="password"
                          id="UserConfirmPassword"
                          value={registerForm?.password_confirmation}
                          onChange={(e) => {
                            changeInputHandler(
                              "password_confirmation",
                              e?.target?.value
                            );
                          }}
                        />
                        {errors?.password_confirmation && (
                          <label className="error">
                            {removeUnderScore(
                              errors.password_confirmation?.message
                            )}
                          </label>
                        )}
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="col">
                      <div className="input text required">
                        <ReCAPTCHA
                          sitekey="6LfkYv8UAAAAAOkk2GQDVbQcmGgyVuneaPEfvLar"
                          onChange={(e) => {
                            if (e) setDisableSubmit(false);
                            console.log("recaptha res: ", e);
                          }}
                        />
                      </div>
                    </div>
                  </li>
                  <li className="button_ddk" style={{ listStyle: "none" }}>
                    <div className="col">
                      <div className="submit">
                        <input
                          value="Register"
                          type="submit"
                          id="sbt_reg_btn"
                          disabled={disableSubmit}
                        />
                      </div>
                    </div>
                    <div className="col actions">
                      Already registerd?{" "}
                      <a className="link" onClick={() => history.push("/")}>
                        Login Here
                      </a>{" "}
                    </div>
                  </li>
                </ul>
              </fieldset>
            </form>
          </div>
        </section>
      </div>
    </>
  );
};
export default Register;
